module.exports = __webpack_public_path__ + "img/add.645a2f8a.png";